export enum ButtonStyle {
  Pill = "pillButton",
  Text = "textButton",
  Video = "videoButton",
}
